import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/opt/homebrew/lib/node_modules/workbox-cli/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "js/bootstrap.js",
    "revision": "7536229d93d7ba2ef1620b8a14fc32a5"
  },
  {
    "url": "js/main.js",
    "revision": "a8d40469d3d72ab4b11059362f3dd825"
  },
  {
    "url": "js/app.min.js",
    "revision": "8570138b465673952368f1406dd5a4de"
  },
  {
    "url": "js/extensions.min.js",
    "revision": "65998885ad5af2f6a14315f3cd9e4d4c"
  },
  {
    "url": "js/orgchart.min.js",
    "revision": "619d8c4dab47b81868916df31f55478b"
  },
  {
    "url": "js/stencils.min.js",
    "revision": "2932a9b572ced97336764408a2266f79"
  },
  {
    "url": "js/shapes-14-6-5.min.js",
    "revision": "04c8d9b709f15514592b337ad33aad74"
  },
  {
    "url": "js/math-print.js",
    "revision": "2906865fa4f7824eab9b648a6888db80"
  },
  {
    "url": "index.html",
    "revision": "9de11c65ec13b24c73ace7042bc529cc"
  },
  {
    "url": "styles/grapheditor.css",
    "revision": "23cbac10c03279392888893b3f694007"
  },
  {
    "url": "styles/high-contrast.css",
    "revision": "4ecc9f6d08787a9e2d29dacf7aadd1ca"
  },
  {
    "url": "js/dropbox/Dropbox-sdk.min.js",
    "revision": "4b9842892aa37b156db0a8364b7a83b0"
  },
  {
    "url": "js/onedrive/OneDrive.js",
    "revision": "e863f5e6833892f22492211663e3efe9"
  },
  {
    "url": "js/viewer-static.min.js",
    "revision": "dfcebfbe5a5478e2052d1fd421d4f396"
  },
  {
    "url": "plugins/cConf-comments.js",
    "revision": "e4a4b5a0fb22393693d3b62968c50644"
  },
  {
    "url": "plugins/cConf-1-4-8.js",
    "revision": "9b5e217aed7dd67a665ea42311b4b0c3"
  },
  {
    "url": "connect/confluence/connectUtils-1-4-8.js",
    "revision": "f504cd3dc65149ee534eca2519545a26"
  },
  {
    "url": "connect/new_common/cac.js",
    "revision": "443fb416a407b8a183d0c8f4ecf68808"
  },
  {
    "url": "connect/gdrive_common/gac.js",
    "revision": "ac3a28fa16c3e6a36af854fcfc018a81"
  },
  {
    "url": "connect/onedrive_common/ac.js",
    "revision": "37c626698573f4419ab9f7ecd7b4bb01"
  },
  {
    "url": "connect/confluence/viewer-init.js",
    "revision": "17d1e02ebb74569f2daa7cf18fed0b02"
  },
  {
    "url": "connect/confluence/viewer.js",
    "revision": "f25b33ded1392fbb5fcf11b7001f90cd"
  },
  {
    "url": "connect/confluence/viewer-1-4-42.html",
    "revision": "69c1bca25fd4889bf832e8441c972268"
  },
  {
    "url": "connect/confluence/macroEditor-1-4-8.html",
    "revision": "4ad77ae3f08c19eddac932b2fa8c7068"
  },
  {
    "url": "connect/confluence/includeDiagram-1-4-8.js",
    "revision": "489bc44e46d6481277c3f2a5d81a2db6"
  },
  {
    "url": "connect/confluence/includeDiagram.html",
    "revision": "01b04b3f54f1e2e63fcf1df033d24519"
  },
  {
    "url": "connect/confluence/macro-editor.js",
    "revision": "87e040c6d8cd60105ec027eae13ddf37"
  },
  {
    "url": "resources/dia.txt",
    "revision": "66fe818e43b096f060797233ac192e69"
  },
  {
    "url": "mxgraph/css/common.css",
    "revision": "81d1704d5ab9207e2e5c7fc84379dc1a"
  }
], {
  "ignoreURLParametersMatching": [/.*/]
});








